import { render, staticRenderFns } from "./u-pagination.vue?vue&type=template&id=c25bf72c&scoped=true&"
import script from "./u-pagination.vue?vue&type=script&lang=js&"
export * from "./u-pagination.vue?vue&type=script&lang=js&"
import style0 from "./u-pagination.vue?vue&type=style&index=0&id=c25bf72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25bf72c",
  null
  
)

export default component.exports